/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from 'primereact/card';
import { Dropdown } from "primereact/dropdown";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import LayoutWrapper from "./LayoutWrapper";
import Highcharts from "highcharts";
import { gql, useMutation } from "@apollo/client";
import { MULTI_FIELD_READ_MUTATION } from "./adapters/utils/constants";

export function SSPDashboard() {
    const [fieldReadMutation] = useMutation(MULTI_FIELD_READ_MUTATION)
    const { currentCustomer, customers, isAgency }
        = useSelector((state) => state.userInformation);
    const [reportingUrl, setReportingUrl] = useState(null)

    useEffect(() => {
        if (currentCustomer) {
            fieldReadMutation({
                variables: {
                    fieldDefinitions: JSON.stringify([{
                        field_name: 'adapter_report',
                        post_id: currentCustomer,
                        parse: false
                    }])
                }
            }).then(response => {
                const data = JSON.parse(response.data.multiFieldRetrieveMutation.response)
                setReportingUrl(data.adapter_report)
                console.log(data)
            }).catch(err => {
                console.log({ err })
            })
        }
    }, [currentCustomer])

    return (
        <LayoutWrapper
            model="adapter"
            renderOpsBar={true}

        >
            <section
                id="reporting-dashboard"
                css={css`
                    iframe {
                        width: 100%;
                        height: calc(100vh - 250px) !important; 
                    }     
                `}
            >
                {
                    reportingUrl
                        ? <iframe src={reportingUrl}></iframe>
                        : (
                            <div
                                css={css`
                            background-color: #f3edbe;
                            border-left: 6px solid #f44333;
                            padding: 3em 1em;
                            border-radius: 6px;
                            max-width: 768px;
                            margin-top: 2em;
                            > p {
                                font-size: 1.5em;
                            }
                        `}
                            >
                                <p>
                                    There is no reporting available for this customer, yet.
                                </p>
                            </div>
                        )
                }
            </section>
        </LayoutWrapper>
    )
}
